import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import ContactView from './ContactView';
import {apiRequest, apiPost, apiDelete} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import {isNullEmptyOrWhitespace, IsNullOrUndefined, SHORT_DATE_FORMAT} from "../../constants";
import 'react-table/react-table.css';
import ReactTable from 'react-table';

class ContactsView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      contacts: [],
      selectedContact: null,
      loading: true,
    };

    this.handleNewContact = this.handleNewContact.bind(this);
    this.handleSaveContact = this.handleSaveContact.bind(this);
    this.handleCancelContact = this.handleCancelContact.bind(this);
    this.loadContacts = this.loadContacts.bind(this);
    this.handleSaveContact = this.handleSaveContact.bind(this);
    this.handleInviteContact = this.handleInviteContact.bind(this);
    this.saveContact = this.saveContact.bind(this);
    this.handleInviteContactCancel = this.handleInviteContactCancel.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }


  handleNewContact() {
    let count = this.state.contacts.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    this.setState({selectedContact: {id: (-1 - count), firstName: '', lastName: '', position: '', addresses: [], communications: [], notes: [], attachments: []}});
  }


  async handleSaveContact(val) {
    let contacts = await this.saveContact(val);

    this.setState({contacts, selectedContact: null}, async () => {
      await this.loadContacts();
    });
  }

  async saveContact(val) {
    let {parentEntityId, parentEntityName} = this.props;
    let contacts = [...this.state.contacts];

    await apiPost(`/api/contacts/${parentEntityName}/${parentEntityId}`, val)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving contact, error: ${x.error ? x.error : x.data.Message}`);
          throw 'Error while saving contact';
        } else {
          let added = false;
          contacts = [...this.state.contacts].map(x => {
            let returnVal = x;
            if (returnVal.id == val.id) {
              added = true;
              return val;
            }
            return returnVal;
          });
          if (!added) {
            contacts = [...this.state.contacts, val];
          }
        }
      });
    return contacts;
  }

  async handleInviteContact(val) {
    let {parentEntityId, parentEntityName} = this.props;
    toastr.success('Saving, then inviting...');

    let contacts = await this.saveContact(val);

    let inviteRequest = {
      contactId: val.id,
    };

    if (parentEntityName === 'clients') {
      inviteRequest.toClientId = parentEntityId;
    } else if (parentEntityName === 'locations') {
      inviteRequest.toLocationId = parentEntityId;
    }

    this.setState({contacts, selectedContact: null});

    toastr.success('Inviting, this may take a moment...');

    await apiPost(`/api/invites/sendinvitecontact`, inviteRequest)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error sending invite, error: ${x.error ? x.error : x.data.Message}`);
          throw 'Error while saving contact';
        } else {
          this.loadContacts();
          toastr.success('Invited contact');
        }
      });
  }


  async handleInviteContactCancel(val) {
    
    toastr.success('Saving, then cacnelleing invite...');

    let contacts = await this.saveContact(val);

    let inviteRequest = {
      contactId: val.id,
    };

    this.setState({contacts, selectedContact: null});

    toastr.success('Cancelling, this may take a moment...');

    await apiPost(`/api/invites/cancel`, inviteRequest)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error sending invite, error: ${x.error ? x.error : x.data.Message}`);
          throw 'Error while saving invite';
        } else {
          this.loadContacts();
          toastr.success('Invited cancelled');
        }
      });
  }


  handleCancelContact(){
    this.setState({selectedContact: null});
  }

  async handleContactDelete(c){
    if(confirm('Are you sure you want to delete contact?')){
      let {parentEntityId, parentEntityName} = this.props;
      await apiDelete(`/api/contacts/${parentEntityName}/${parentEntityId}/${c.id}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while deleting contact, error: ${x.error ? x.error : x.data.Message}`);
          } else {
            let contacts = this.state.contacts.filter(x => x.id != c.id);
            this.setState({contacts});
            this.loadContacts();
          }
        });
    }
  }

  handleSelectContact(ev, communication) {
    ev.preventDefault();
    this.setState({selectedContact: communication});
  }

  async loadContacts() {
    let {parentEntityId, parentEntityName} = this.props;
    
    if (parentEntityId <= 0 || isNullEmptyOrWhitespace(parentEntityName)) {
      return;
    }
    this.setState({loading: true});
    await apiRequest(`/api/contacts/${parentEntityName}/${parentEntityId}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching contacts, error: ${x.error ? x.error : x.data.Message}`);
          this.setState({loading: false});
        } else {
          this.setState({contacts: Array.from(x.data), loading: false});
        }
      });
  }

  getColumns() {
    return [
      
      {
        accessor: 'position',
        Header: 'Position',
      },
      {
        id: 'firstName',
        accessor: c => (<a href="#" onClick={(e)=>this.handleSelectContact(e, c)} >{c.firstName}</a>),
        Header: 'First Name',
      },
      {
        id: 'lastName',
        accessor: c => (<a href="#" onClick={(e)=>this.handleSelectContact(e, c)} >{c.lastName}</a>),
        Header: 'First Name',
      }, 
      {
        id: 'updatedDate',
        Header: 'Updated',
        accessor: c => (c.id > 0 ? moment(c.updatedDate ? c.updatedDate : c.createdDate).format("DD/MM/YYYY h:mm:ss a") : ''),
      },
      {
        accessor: 'updatedBy',
        Header: 'Updated By',
      },
      {
        id: 'action',
        Header: '',
        accessor: c => (<Button color="danger" onClick={() => this.handleContactDelete(c)}><i className="fa fa-times" /></Button>),
        maxWidth: 60,
      }
    ];
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {parentEntityId, parentEntityName} = this.props;
    if (prevProps.parentEntityId !== parentEntityId || prevProps.parentEntityName !== parentEntityName) {
      this.loadContacts().then(() => {});
    }
  }

  componentDidMount() {
    this.loadContacts().then(() => {});
  }

  render() {
    let {selectedContact, contacts, loading} = this.state;
    let {parentEntityName} = this.props;
    let isInvitable = this.props.isSuperUser
        && selectedContact && selectedContact.communications.filter(x => x.communicationType.toLowerCase().includes('email')).length > 0
        && (parentEntityName === 'clients' || parentEntityName === 'locations');

    return (contacts) && (
        <div style={{marginTop: '20px', marginBottom: '20px'}}>
          <Modal
              style={{maxWidth: '650px'}}
              isOpen={selectedContact != null}
          >
            <ModalBody>
              {selectedContact && <ContactView
                  contact={selectedContact == null ? {} : selectedContact}
                  onCancel={this.handleCancelContact}
                  onSave={this.handleSaveContact}
                  onInvite={isInvitable ? this.handleInviteContact : null}
                  onCancelInvite={isInvitable ? this.handleInviteContactCancel : null}
                  isEdit={true}
              />}
            </ModalBody>
          </Modal>

          <div className="form-group row">
            <div className={"col-12"}>
              <h6>
                Contacts&nbsp;{/*<small><i>Instead of adding a contact, invite the user to join Location or Client</i></small>*/}
                <Button color="success" onClick={this.handleNewContact}><i className="fa fa-plus"/>&nbsp;&nbsp;Add
                  contact</Button>
              </h6>
            </div>
          </div>

          <div className="form-group row">
            <div className="col-12 col-md-12 col-xl-12">
              {loading ?
                  <div>Loading contacts...</div> :
                  <ReactTable
                      sortable={false}
                      filterable={false}
                      showPagination={false}
                      data={contacts}
                      columns={this.getColumns()}
                      minRows={2}
                  />}
            </div>
          </div>
        </div>
    );
  }
}

ContactsView.propTypes = {
  parentEntityName: PropTypes.string.isRequired,
  parentEntityId: PropTypes.number.isRequired,
  isSuperUser: PropTypes.bool
,};

export default ContactsView;